<template>
  <div>
    <CustomModal :show="showModal"
                 title="Consumir Impressos de Segurança"
                 size="sd"
                 @closeModal="() => {showModal = false; resolveModal(false)}"
                 @ok="() => updatePapeisSelecionados()">
      <div>
        <h5>
          Escolha um dos papéis que não foram utilizados:
        </h5>
        <small class="text-info">Caso o papel desejado não se encontre na lista abaixo, é possível digitá-lo.</small>
      </div>
      <div v-for="(item, index) in itensOs"
           :key="index"
           class="mt-4">
        <div v-if="item.impressosSeguranca && !item.ordem_servico_item_id">
          <span><b>Custa (Ato):</b> {{ item.custa.ato }} </span><br>
          <small class="text-info m-0 p-0"
                 for="impresso"><span class="pr-1">Tipo Papel: </span>{{ formatString(item.custa.impresso_seguranca) }}</small>
          <CustomSelect :options="options(item)"
                        class="mt-2"
                        label="Selecione o número do lote"  
                        :selected="item.papeisSelecionados.map((item) => item.numero_serie).join(', ')"                
                        :max-height-display="400"
                        @setSelectValue="(ev) => setPapeis(ev, item)" />
        </div>
      </div>
    </CustomModal>
  </div>
</template>

<script>

  // Components
  import CustomModal from '@/components/CustomModal/CustomModal'
  import CustomSelect from '@/components/CustomInputs/CustomSelect.vue'
  import { formatString } from "@//utils/conversors.js"


  export default {
    name: "PapelConsumo",
    components: {
      CustomModal,
      CustomSelect
    },
    props: {
      propItensOs: {
        type: Array,
        default: () => []
      },
    },
    data () {
      return {
        showModal: false,
        itensOs: [],
        todosPapeisSelecionados: [],
        resolveModal: null
      }
    },
    computed: {

    },
    computed: {
      options () {
        return (item) => {
          // Os papeis disponiveis não devem estar contigos em "this.todosPapeisSelecionados" que representa todos os papeis selecionados
          const numSerie = item.papeisDisponiveis.filter((obj) => !this.todosPapeisSelecionados.includes(obj.numero_serie))          
          const options = numSerie.map((papel, indexPapel) => ({ value: papel, text: papel.numero_serie, index: indexPapel }))
          return options
        }
      }
    },
    watch: {
      'propItensOs.length' () {
        this.init()
      }
    },
    async created () {
      this.init()
    },
    methods: {
      async init () {
        if (this.propItensOs.length) {
          this.itensOs = this.propItensOs
          this.itensOs.map((item) => item.getImpressosDisponiveis())
        }
      },
      setPapeis (option, item) {
        // Caso seja null reinicia os valores e retorna
        if (!option) return this.handlerUnset(item)

        // Reunimos algumas informações necessarias para verificar se há papeis sucifiente
        let indexPapel = option.index
        const totalPapeis = item.papeisDisponiveis.length
        const qtItens = item.quantidade
        // Verificamos
        const verificaDisponibilidade = (totalPapeis - indexPapel) >= qtItens ? true : false
        // Caso seja verdadeiro adicionamos tantos papeis disponives quanto a quantidade de itens
        if (verificaDisponibilidade) {
          const papeisItem = []
          for (let i = 1; i <= qtItens; i++) {
            papeisItem.push(item.papeisDisponiveis[indexPapel])
            // Salva um historico de todos os papeis selecionados
            this.todosPapeisSelecionados.push(item.papeisDisponiveis[indexPapel].numero_serie) 
            indexPapel++
          }
          // Atualiza array de papeis selecionados do item
          item.papeisSelecionados = papeisItem
          // Removemos os papeis selecionados do array de papeis disponiveis dos demais itens da OS
          this.handlerItensSelecionados()
        } else {
          // Como não há papeis disponives reinicia
          this.handlerUnset(item)
          item.papeisSelecionados = []
          displayMessage('error', 'Erro', 'Não há papéis suficientes, após o selecionado, para o número de custas criadas | Total de Custas')
        }
      },
      handlerUnset (item) {
        // Retorna array com numeros de serie selecionados
        const papeis = item.papeisSelecionados.map(item => item.numero_serie)
        // Remove os papeis selcionados do array que guarda o historico de todos os papeis selecionados
        this.todosPapeisSelecionados = this.todosPapeisSelecionados.filter(obj => !papeis.includes(obj))
        // Reinia os pepeis selecionados do item porque o retorno é null
        item.papeisSelecionados = []
        // Atualiza os demais itens da OS para liberar os pepeis deselecionados
        this.handlerItensSelecionados()
      },
      async handlerItensSelecionados () {
        for (const item of this.itensOs) {
          // Pegamos novamente os papeis disponiveis uma vez que podem ter sido removidos anteriormente
          await item.getImpressosDisponiveis()
          // Percorre todos os itens e remove os papeis disponiveis que permenencem selecionados
          item.papeisDisponiveis = item.papeisDisponiveis.filter(obj => !this.todosPapeisSelecionados.includes(obj.numero_serie))
        }
      },
      updatePapeisSelecionados () {
        this.$emit('updatePapeisSelecionados', this.itensOs)
        this.resolveModal(true)
        this.showModal = false
      },
      createModalPromise () { // Usado para aguardar retorno antes de continuar uma função
        this.showModal = true
        return new Promise((resolve) => {
          this.resolveModal = resolve
        })
        
      },
      formatString (value) {
        return formatString(value)
      }
    }
  }
</script>

<style lang="scss"> 
 
</style>
